/* Reuse the basket threshold rendered by free-shipping-notice. */
if (!customElements.get('bh3d-hero-delivery')) {
  customElements.define('bh3d-hero-delivery', class extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      this.events = ['on:cart:add', 'on:line-item:change', 'on:cart-drawer:after-close'];
      this.events.forEach(name => document.addEventListener(name, this.refresh));
      window.addEventListener('pageshow', this.refresh);
      this.refresh();
    }
    disconnectedCallback() {
      this.events.forEach(name => document.removeEventListener(name, this.refresh));
      window.removeEventListener('pageshow', this.refresh);
      this.controller?.abort();
    }
    async refresh() {
      const minimum = Number(this.dataset.minimum);
      if (!this.dataset.minimum || !Number.isFinite(minimum)) return;
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 8000);
      const label = this.querySelector('span');
      try {
        const response = await fetch(this.dataset.cartUrl, {signal: controller.signal, cache: 'no-store'});
        if (!response.ok) throw new Error('Basket unavailable');
        const cart = await response.json();
        if (!this.isConnected || controller !== this.controller) return;
        if (!Number.isFinite(cart.total_price) || cart.currency !== this.dataset.currency) throw new Error('Basket currency changed');
        const remaining = Math.max(0, minimum - cart.total_price);
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency', currency: cart.currency
        }).format(remaining / 100);
        label.textContent = remaining > 0 ? amount + ' to free delivery' : 'Your basket qualifies';
      } catch (error) {
        if (controller === this.controller && this.isConnected) label.textContent = 'Check delivery in your basket';
      } finally {
        clearTimeout(timeout);
      }
    }
  });
}
